import React from 'react';

type FAQItemProps = {
  item: { question: string; answer: string };
  index: number;
};

export default function FAQItem({ item, index }: FAQItemProps) {
  const id = `faq-${index}`;
  const [open, setOpen] = React.useState(false);
  return (
    <div
      className={`bg-white border rounded-lg shadow-lg hover:shadow-xl transition-shadow ${open ? 'border-green-700' : 'border-gray-200'}`}>
      <button
        className="w-full p-4 flex justify-between items-center text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-green-700 rounded-lg"
        aria-expanded={open}
        aria-controls={`${id}-panel`}
        onClick={() => setOpen((v) => !v)}>
        <span className="font-medium text-gray-900">{item.question}</span>
        <span
          className={`text-xl transition-transform duration-200 ${open ? 'rotate-45' : ''}`}
          aria-hidden>
          +
        </span>
      </button>
      <div
        id={`${id}-panel`}
        role="region"
        aria-labelledby={id}
        className={`px-4 pb-4 text-left text-base text-gray-700 grid transition-[grid-template-rows,opacity] duration-200 ease-out ${
          open ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
        }`}
        style={{ overflow: 'hidden' }}>
        <div className="min-h-0">{item.answer}</div>
      </div>
    </div>
  );
}
